import { AgentTerminal } from './AgentTerminal';
import c from './Landing.module.css';
import { STATS } from './data';

export function Hero() {
  return (
    <header className={`${c.container} ${c.hero}`}>
      <div>
        <div className={c.badge}>
          <span className={c.dot} />
          TORONTO · GTA · NORTH AMERICA
        </div>
        <h1 className={c.h1}>
          Transforming enterprises <span className={c.gradientText}>with AI.</span>
        </h1>
        <p className={c.lede}>
          An AI consulting and engineering studio in Toronto. 20+ years shipping AI, Cloud, Web &amp; Mobile for clients across
          the GTA and North America, alongside twelve platforms of our own.
          Engineered by agent teams (<strong>Claude Code, Codex, Hermes agents, OpenClaw</strong>) supervised by senior engineers.
        </p>
        <div className={c.ctas}>
          <a href="#contact" className={c.btnPrimary}>Start a project →</a>
          <a href="#work" className={c.btnSecondary}>See our work</a>
        </div>
        <div className={c.stats}>
          {STATS.map((s) => (
            <div key={s.label}>
              <div className={c.statValue}>{s.value}</div>
              <div className={c.statLabel}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>
      <AgentTerminal />
    </header>
  );
}
